@if (navigation) {
  <button (click)="prevMonth()" mat-flat-button navigation>
    <mat-icon>arrow_left</mat-icon>
  </button>
}
<mat-card [class]="class">
  <mat-card-header>
    <mat-card-title>
      <div>{{ name }}</div>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="week">
      <div class="num"></div>
      @for (day of dayNames; track $index) {
        <div class="day">{{ day }}</div>
      }
    </div>
    @for (week of weeks; track $index) {
      <div class="week">
        <div class="num">{{ week.nr }}</div>
        @for (day of week.days; track $index) {
          <cal-day (clickEvent)="activateDay(day)" [day]="day"></cal-day>
        }
      </div>
    }
  </mat-card-content>
</mat-card>
@if (navigation) {
  <button (click)="nextMonth()" mat-flat-button navigation>
    <mat-icon>arrow_right</mat-icon>
  </button>
}
